<!-- Component Header with Loading State and Refresh Button -->
<div class="ai-citations-header">
  <div class="header-content">
    <h2 class="component-title">
      <mat-icon>format_list_numbered</mat-icon>
      {{ title }}
    </h2>
    <div class="header-actions">
      @if (isLoading) {
        <mat-spinner diameter="24"></mat-spinner>
        <span class="loading-text">Loading...</span>
      } @else {
        <button mat-icon-button (click)="refreshData()" matTooltip="Refresh Data">
          <mat-icon>refresh</mat-icon>
        </button>
      }
    </div>
  </div>
  @if (error) {
    <div class="error-message">
      <mat-icon>error</mat-icon>
      <div class="error-content">
        <span class="error-text">{{ error }}</span>
        <button mat-button color="primary" (click)="refreshData()" [disabled]="isLoading">
          <mat-icon>refresh</mat-icon>
          Retry
        </button>
      </div>
    </div>
  }
</div>

<!-- Main Content -->
@if (aiCitationsResponse && hasData()) {
<div class="ai-citations-container">
  <!-- Top Row: Score Widget and Chart -->
  <div class="top-row">
    <!-- Composite Score Widget -->
    <app-composite-score-widget
      [compositeScore]="compositeScore"
      [title]="'AI Citations Score'"
      [size]="'medium'">
    </app-composite-score-widget>

    <!-- AI Citations Chart -->
    <div class="chart-section">
      <div class="chart-header">
        <div class="chart-title-section">
          <h4 class="chart-title">AI Citations Index</h4>
          <p class="chart-subtitle">{{ getChartSubtitle() }}</p>
        </div>
      </div>

      <!-- AI Citations Chart -->
      <div class="chart-mobile-wrapper">
        <div *ngIf="shouldShowComboChart()" class="combo-chart-wrapper">
          <app-bar-line-combo-chart
            [view]="view"
            [scheme]="comboBarScheme"
            [colorSchemeLine]="lineChartScheme"
            [results]="results"
            [lineChart]="lineChart"
            [barBrandName]="'Bar Chart'"
            [animations]="true"
            [tooltipDisabled]="false"
            [yAxisTickFormatting]="yLeftTickFormat"
            [yLeftAxisScaleFactor]="yLeftAxisScale"
            [yRightAxisScaleFactor]="yRightAxisScale"
            [yRightAxisTickFormatting]="yRightTickFormat"
            [gradient]="false"
            [xAxis]="true"
            [yAxis]="true"
            [legend]="true"
            [legendTitle]="'Universities'"
            [legendPosition]="'right'"
            [showGridLines]="true"
            [showXAxisLabel]="true"
            [showYAxisLabel]="true"
            [showRightYAxisLabel]="true"
            [xAxisLabel]="'AI Citations Metrics'"
            [yAxisLabel]="'Score'"
            [yAxisLabelRight]="'Score'"
            [noBarWhenZero]="true"
            [wrapTicks]="false"
            (select)="onSelect($event)"
            (activate)="onActivate($event)"
            (deactivate)="onDeactivate($event)">
          </app-bar-line-combo-chart>
        </div>
      </div>
    </div>
  </div>

  <!-- Performance Table -->
  <app-common-performance-table
    [rows]="tableRows"
    [columns]="tableColumns"
    [title]="'AI Citations Performance'">
  </app-common-performance-table>

  <!-- Most Cited Domains in Education Sector -->
  <div class="cited-domains-section">
    <mat-card class="cited-domains-card">
      <mat-card-header>
        <mat-card-title>Most Cited Domains in Education Sector</mat-card-title>
        <mat-card-subtitle>Top domains with highest citation authority and traffic</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <div class="table-container">
          <table class="cited-domains-table">
            <thead>
              <tr>
                <th class="domain-column">Domain</th>
                <th class="authority-column">Authority Score</th>
                <th class="traffic-column">Approx. Monthly Organic Traffic</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let domain of citedDomainsData; let i = index" [class.highlight-row]="i < 3">
                <td class="domain-cell">
                  <div class="domain-name">{{ domain.domain }}</div>
                </td>
                <td class="authority-cell">
                  <div class="authority-value">{{ domain.authority_score }}</div>
                  <div class="authority-bar">
                    <div class="authority-fill" [style.width.%]="domain.authority_score"></div>
                  </div>
                </td>
                <td class="traffic-cell">
                  <div class="traffic-value">{{ domain.monthly_traffic }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

    <!-- Strengths and Areas for Improvement - Using Common Component -->
    <app-common-strengths-improvement
      *ngIf="hasData()"
      [data]="getStrengthsImprovementData()"
      [title]="'Strengths and Areas for Improvement'"
      [subtitle]="'Comprehensive analysis of university performance'"
      [showCard]="true">
    </app-common-strengths-improvement>

    <!-- Context Sources -->
    <div class="citations-section" *ngIf="aiCitationsResponse.context?.citations?.length">
      <h4>Context Sources:</h4>
      <app-common-sources
        [evidenceSources]="transformCitationsToEvidenceSources(aiCitationsResponse.context.citations || [])"
        [title]="'Data Sources & Evidence'" [showTitle]="false">
      </app-common-sources>
    </div>







    <!-- region hidden-section -->

    <!-- AI Citations Analysis -->
    <!-- <div class="context-section" style="display: none;">
    <mat-card class="context-card">
      <mat-card-header>
        <mat-card-title>AI Citations Analysis</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        Insights -->
    <!-- <div class="insights" *ngIf="aiCitationsResponse?.context?.insights?.length">
          <h4>Key Insights:</h4>
          <div class="insights-list">
            <div class="insight-item" *ngFor="let insight of aiCitationsResponse.context.insights">
              <mat-icon>lightbulb</mat-icon>
              <span>{{ insight }}</span>
            </div>
          </div>
        </div> -->
    <!-- </mat-card-content>
    </mat-card>
    </div> -->

    <!-- Detailed AI Citations Metrics -->
    <!-- <div class="metrics-section" style="display: none;">
      <mat-card class="metrics-card">
        <mat-card-header>
          <mat-card-title>Detailed AI Citations Metrics</mat-card-title>
          <mat-card-subtitle>Comprehensive breakdown of AI adoption metrics</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="metrics-table">
            <table class="ai-metrics-table">
              <thead>
                <tr>
                  <th>University</th>
                  <th>AI Citations Score</th>
                  <th>Content Quality</th>
                  <th>Digital Presence</th>
                  <th>Innovation Index</th>
                  <th>AI Adoption Rate</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let university of aiCitationsResponse.universities">
                  <td>{{ university.name }}</td>
                  <td>{{ university.citation_frequency | number:'1.0-1' }}</td>
                  <td>{{ university.citation_share_of_voice | number:'1.0-1' }}</td>
                  <td>{{ university.authority_weight | number:'1.0-1' }}</td>
                  <td>{{ university.relevance_score | number:'1.0-1' }}</td>
                  <td>{{ university.ai_readability | number:'1.0-1' }}%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </mat-card-content>
      </mat-card>
    </div> -->

    <!-- Analysis Information -->
    <!-- <div class="meta-section">
      <mat-card class="meta-card">
        <mat-card-header>
          <mat-card-title>Analysis Information</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="meta-grid">
            <div class="meta-item">
              <strong>Universities Analyzed:</strong>
              <div class="university-list">
                <span class="university-chip" *ngFor="let university of aiCitationsResponse.universities">
                  {{ university.name }}
                </span>
              </div>
            </div>
            <div class="meta-item">
              <strong>Model Used:</strong> {{ aiCitationsResponse.model_meta.model_used }}
            </div>
            <div class="meta-item">
              <strong>Search Engines:</strong>
              <div class="engine-chips">
                <span class="engine-chip" *ngFor="let engine of aiCitationsResponse.model_meta.search_engines">
                  {{ engine }}
                </span>
              </div>
            </div>
            <div class="meta-item">
              <strong>Data Freshness:</strong> {{ aiCitationsResponse.model_meta.data_freshness }}
            </div>
            <div class="meta-item">
              <strong>Processing Time:</strong> {{ aiCitationsResponse.model_meta.processing_time }}s
            </div>
            <div class="meta-item">
              <strong>Analysis Time:</strong> {{ aiCitationsResponse.timestamp | date:'medium' }}
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div> -->

    <!-- endregion hidden-section -->
</div>
}
